// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1N_T3","right":"styles_right__2ICRr"};